import { render } from "./infoEl.vue?vue&type=template&id=3c59c737&scoped=true"
import script from "./infoEl.vue?vue&type=script&lang=js"
export * from "./infoEl.vue?vue&type=script&lang=js"

import "./infoEl.vue?vue&type=style&index=0&id=3c59c737&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-3c59c737"

export default script